// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_fr-0";
export var fulfillmentPanelBody = "_fr-1";